
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';

@MergeSchema({
    entity: ActivityEntityName.Code,
    name: 'StageItemsMergeSchema',
})
export class StageItemMergeData {

    @MergeField()
    _id: string;

    @MergeField()
    name?: string;

    @MergeField()
    source?: string;

    @MergeField()
    buyPrice?: number = 0

    @MergeField()
    sellPrice?: number = 0

    @MergeField()
    customBuyPrice?: boolean;

    @MergeField()
    customSellPrice?: boolean;

    @MergeField()
    status?: string;

    @MergeField()
    invoicingStatus: string;

    /** 'Payable' or 'Not Payable'. Derived, because an absent flag on the line reads as Payable. */
    @MergeField()
    payableStatus: string;

    @MergeField()
    location?: string;

    @MergeField()
    note?: string;

    @MergeField()
    codeUoM?: string;

    @MergeField()
    baseQuantity?: number;

    @MergeField()
    suppliedBySubcontractor?: boolean;

    @MergeField()
    upc?: string;

    @MergeField()
    description: string;

    @MergeField()
    longDescription?: string;

    @MergeField()
    quantity?: number;

    @MergeField({
        displayName: 'Sub Total Buy'
    })
    subTotalBuy: string;

    @MergeField({
        displayName: 'Sub Total Sell'
    })
    subTotalSell: string;

    @MergeField()
    sellTax?: string;

    @MergeField()
    totalSellIncTax?: string;

    @MergeField()
    completed?: boolean;

    @MergeField()
    itemTaskCompleted?: boolean;

    @MergeField()
    comply?: string;

    rawValues?: any
}

export const StageItemsMergeSchema = getSchema(StageItemMergeData);

